module.exports = __webpack_public_path__ + "media/LandingPageAssets/AutoAdjuster-1e036ebc.png";